export default __webpack_public_path__ + "static/thebottomline23-c3a05b65512508867a9d752944ca5069.jpg";